import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { OwnerService } from '../../core/services/owner.service';
import { PagerComponent } from '../../shared/components/pager.component';

@Component({
    selector: 'app-owner-list',
    imports: [RouterLink, FormsModule, PagerComponent],
    template: `
<div class="animated fadeIn container-fluid">
    <div class="card">
      <div class="card-header">
        <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
      </div>
      <div class="card-body">
        <div style="height: 1px"></div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-form-label" for="keyword">キーワード検索</label>
              <input id="keyword" name="keyword" type="text" [ngModel]="keyword"
                (ngModelChange)="keyword = $event; pageIndex = 0"
                class="form-control" placeholder="店舗名など">
            </div>
          </div>
        </div>
        <hr>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-12">
            <button class="btn btn-primary text-white" type="button" routerLink="/owner/new">
              <i class="fa s-icon-plus"></i>&nbsp;新規作成
            </button>
          </div>
        </div>
        @if (searching) {
          <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
        }
        @if (!searching && filteredItems.length === 0) {
          <span>該当するデータはありません</span>
        }
        @if (filteredItems.length > 0) {
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          <table class="table table-bordered table-sm table-hover table-ptb-0">
            <thead>
              <tr>
                <th width="10%">状態</th>
                <th width="5%">ID</th>
                <th width="20%">企業名</th>
                <th width="45%">住所</th>
                <th width="10%">電話番号</th>
                <th width="10%"></th>
              </tr>
            </thead>
            <tbody>
              @for (item of pagedItems; track item.id) {
                <tr>
                  <td class="text-center">
                    @if (item.status === 0) {
                      <button class="btn text-green p-0 bg-inherit active" type="button" (click)="setStatus(item, 1)">
                        <i class="fa fa-3x fa-toggle-on"></i>
                      </button>
                    } @else {
                      <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="setStatus(item, 0)">
                        <i class="fa fa-3x fa-toggle-off"></i>
                      </button>
                    }
                  </td>
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>〒&nbsp;{{ item.zip }}&nbsp;{{ item.province }}&nbsp;{{ item.city }}&nbsp;{{ item.area }}&nbsp;{{ item.address }}</td>
                  <td>{{ item.phone }}</td>
                  <td class="text-center">
                    <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                      [routerLink]="['/owner/edit', item.id]" title="編集">
                      <i class="fa s-icon-edit fa-fw"></i>
                    </a>
                    @if (item.status === 0) {
                      <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled title="削除">
                        <i class="fa s-icon-delete fa-fw"></i>
                      </button>
                    }
                    @if (item.status === 1) {
                      <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" title="削除"
                        (click)="openDeleteModal(item)">
                        <i class="fa s-icon-delete fa-fw"></i>
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        }
      </div>
    </div>
  @if (showDeleteModal) {
    <div class="modal-backdrop fade show"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content border-danger">
          <div class="modal-header bg-danger">
            <h5 class="modal-title"> 企業の削除</h5>
            <button type="button" class="close" (click)="showDeleteModal = false">
              <span class="text-white" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #FFF6F8 !important">
            <div class="form-group row">
              <label class="col-md-12 col-form-label">企業を削除します。よろしいですか。</label>
            </div>
          </div>
          <div class="modal-footer" style="background-color: #FFF6F8 !important">
            <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
              <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
            </button>
            <button class="btn btn-danger" type="button" (click)="doDelete()">
              <i class="fa s-icon-delete"></i>&nbsp;削除
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
  `
})
export class OwnerListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private authState = inject(AuthStateService);
  private ownerService = inject(OwnerService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  items: any[] = [];
  keyword = '';
  searching = true;
  readonly pageLimit = 100;
  pageIndex = 0;
  showDeleteModal = false;
  selectedItem: any = null;

  get filteredItems(): any[] {
    return this.items.filter(item => matchesNestedKeyword(item, this.keyword));
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }
  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('マスター管理', 's-icon-master');
    try {
      this.items = await this.ownerService.list('all') ?? [];
    } finally {
      this.searching = false;
    }
  }

  async setStatus(item: any, status: number): Promise<void> {
    await this.ownerService.upsert({ id: item.id, status });
    item.status = status;
  }

  openDeleteModal(item: any): void {
    this.selectedItem = item;
    this.showDeleteModal = true;
  }

  doDelete(): void {
    this.showDeleteModal = false;
    this.ownerService.remove(this.selectedItem.id).then(() => {
      this.items = this.items.filter(o => o.id !== this.selectedItem.id);
    });
  }
}
